import { useContext, useState } from 'react';
import InputConfig from '../../Components/InputConfig';
import { SCRIPT_TYPES } from './constants';
import { SPLIT_DOC_PARAMETERS } from '../../core/constants';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Modalv2Context } from '../../Contexts/Modalv2Context';
import ScriptCard from './ScriptCard';
import useCommonStyles from '../../commonStyles';

//mui imports====
import { Grid, Paper, Button } from '@mui/material';
import { toast } from 'react-toastify';

//===============

const { SCRIPTS, TYPE, VALUE, DEFER, ASYNC } = SPLIT_DOC_PARAMETERS;
const { URL } = SCRIPT_TYPES;

const ScriptsConfig = ({ splitDoc, updateSplitDoc }) => {
	const scriptsConfigObj = splitDoc && splitDoc[SCRIPTS];
	const commonStyleClasses = useCommonStyles();

	const { updateModalContent } = useContext(Modalv2Context);

	const updateScript = (scriptKey, udpatedScriptData) => {
		const clonedSplitDoc = structuredClone(splitDoc);
		const clonedScriptsConfigObj = clonedSplitDoc && clonedSplitDoc[SCRIPTS];
		clonedScriptsConfigObj[scriptKey] = udpatedScriptData;
		updateSplitDoc(clonedSplitDoc);
	};

	const addScript = (scriptKey) => {
		if (!scriptKey) {
			toast.error('Type a valid script Name', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
			return;
		}
		const clonedSplitDoc = structuredClone(splitDoc);
		const clonedScriptsConfigObj = clonedSplitDoc && clonedSplitDoc[SCRIPTS];
		if (clonedScriptsConfigObj[scriptKey]) {
			toast.error('Script already present!', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
			return;
		}
		const initialScriptData = { [TYPE]: URL, [VALUE]: '', [DEFER]: false, [ASYNC]: false };
		clonedScriptsConfigObj[scriptKey] = initialScriptData;
		updateSplitDoc(clonedSplitDoc);
		updateModalContent(null);
	};

	const deleteScript = (scriptKey) => {
		const clonedSplitDoc = structuredClone(splitDoc);
		const clonedScriptsConfigObj = clonedSplitDoc && clonedSplitDoc[SCRIPTS];
		delete clonedScriptsConfigObj[scriptKey];
		updateSplitDoc(clonedSplitDoc);
	};

	return (
		<Paper sx={{ padding: '3rem', margin: '3rem 6rem 3rem 3rem' }}>
			<Grid container spacing={2}>
				{scriptsConfigObj && (
					<>
						{Object.keys(scriptsConfigObj).map((scriptKey) => {
							const scriptData = scriptsConfigObj[scriptKey];
							return (
								<ScriptCard
									key={scriptKey}
									scriptKey={scriptKey}
									updateScript={updateScript}
									deleteScript={deleteScript}
									scriptData={scriptData}
								/>
							);
						})}
						<Grid item xs={12} style={{ textAlign: 'center' }}>
							<AddCircleIcon
								color="primary"
								fontSize="medium"
								className={commonStyleClasses.icon}
								onClick={() => {
									updateModalContent(<AddScriptModal addScript={addScript} />);
								}}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
};

const AddScriptModal = ({ addScript }) => {
	const commonStyleClasses = useCommonStyles();

	const [scriptKey, setScriptKey] = useState('');
	return (
		<Grid container spacing={2} className={commonStyleClasses.modalContentStyle}>
			<Grid item xs={12}>
				<InputConfig
					isObjectEditor={false}
					label="Script Name"
					inputType="string"
					directValue={scriptKey}
					updateDirectValue={setScriptKey}
					labelStyles={{ width: '100%' }}
					inputStyles={{ width: '100%' }}
				/>
			</Grid>
			<Grid item xs={12}>
				<Button
					variant="contained"
					onClick={() => {
						addScript(scriptKey);
					}}
				>
					Add New Script
				</Button>
			</Grid>
		</Grid>
	);
};

export default ScriptsConfig;
